import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import DatePicker from "react-datepicker";
import Select, { StylesConfig } from "react-select";
import { TimePicker, TimePickerProps } from "antd";
import customParseFormat from "dayjs/plugin/customParseFormat";
import dayjs from "dayjs";
import { useCreateAppointmentMutation, useGetAppointmentByIdQuery, useLazyGetAppointmentByIdQuery, useUpdateAppointmentMutation } from '../../../../../services/EndPointsApis';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';
import TextField from '../../../../../core/common/textFields/TextField';
import { customStyles } from '../../../../../core/common/Custom Style/CustomStyle';


const AppointmentLeadSidebar = ({ activityTogglePopup, closeSidebar, getdefaultLookups, TriggerApt, aptbyId, isEditing, selectedIndividualCheckboxId, InquiryId, getallActiveUsers }: any) => {
    dayjs.extend(customParseFormat);
    const onChangeStart: TimePickerProps['onChange'] = (time, timeString) => {
        const formattedTime = time ? dayjs(time).format("h:mm A") : '';
        formik.setFieldValue('startTime', formattedTime);
    };
    const [updateId, setUpdateId] = useState(0);
    const id = selectedIndividualCheckboxId;
    const aptId = id[0];
    //Api

    const [createAppointment, { data, isError, error, isSuccess, isLoading }] =
        useCreateAppointmentMutation();

    const [UpdateAppointment, { data: updateData, isError: UpdateIsError, error: updateError, isSuccess: updateIsSuccess, isLoading: updateIsLoading }] =
        useUpdateAppointmentMutation();

    const [lIid, setLiId] = useState(InquiryId)

    //Formik
    const initialValues = {

        appointmentId: 0,
        leadInquiryId: lIid,
        recNumber: '',
        lst_SelAppointmentType: {
            id: 0,
            value: ''
        },
        startDate: "",
        startTime: "",
        lst_duration: {
            id: 0,
            value: ''
        },
        lst_FreshAptLocation: {
            id: 0,
            value: ''
        },
        clientAttendees: '',
        internalAttendees: [{
            id: 0,
            value: ''
        }],
        aptTitle: '',
        locationNotes: "",
        comments: ''
    }
    const formik = useFormik({
        initialValues,
        // validationSchema: contactSchema,
        onSubmit: (values) => {

            if (aptId) {
                UpdateAppointment({ ...values })
            } else {
                createAppointment({ ...values });
            }
        },
    });
    const { resetForm } = formik;

    useEffect(() => {

        if (!aptId && activityTogglePopup) {
            TriggerApt({ Id: -1 })
        }
        else if (aptId && activityTogglePopup) {
            TriggerApt({ Id: aptId })
        }
    }, [aptId, activityTogglePopup])

    useEffect(() => {
        if (isSuccess) {
            toast.success(data?.message);
            resetForm();
            closeSidebar()
            resetForm()
            // navigate('/contacts')
        }
        if (aptId && updateIsSuccess) {
            toast.success(updateData?.message);
            closeSidebar()
            // navigate('/contacts')
        }

    }, [isSuccess, updateIsSuccess]);

    useEffect(() => {
        if (aptbyId?.result && Object.keys(aptbyId?.result).length > 0) {
            setUpdateId(aptbyId?.result?.appointmentId);
            formik.setValues({ ...aptbyId?.result });
            formik.setFieldValue('leadInquiryId', lIid)

        } else {
            setUpdateId(0);
            // resetForm();
        }
    }, [aptbyId, updateId]);

    useEffect(() => {
        setLiId(InquiryId)
    }, [InquiryId])

    useEffect(() => {
        if (isError && error) {
            let errorMessage: string = 'Something went wrong';

            if ('data' in error && error.data && typeof error.data === 'object' && 'message' in error.data) {
                errorMessage = (error.data as { message: string }).message;
            }
            toast.error(errorMessage);
        }
        if (UpdateIsError && updateError) {
            let errorMessage: string = 'Something went wrong';

            if ('data' in updateError && updateError.data && typeof updateError.data === 'object' && 'message' in updateError.data) {
                errorMessage = (updateError.data as { message: string }).message;
            }
            toast.error(errorMessage);
        }
    }, [isError, error, UpdateIsError, updateError]);



    const [selectedDate, setSelectedDate] = useState<Date | null>(null);

    const handleDateChange = (date: Date | null) => {
        setSelectedDate(date);
        formik.setFieldValue('startDate', date)
    };

    const handleSubmit = (e: any) => {
        e.preventDefault()
        formik.handleSubmit()
    }
    const selectValues = formik.values?.internalAttendees
        ? formik.values.internalAttendees
            .filter((attendee: { id: number; value: string }) => attendee.id !== 0 && attendee.value !== '')
            .map((attendee: { id: number; value: string }) => ({
                value: attendee.id,
                label: attendee.value,
            }))
        : [];
    type InternalAttendeeOption = {
        id: number;
        value: string;
        label: string;
    };
    const handleChange = (newValue: any) => {
        const updatedValues: InternalAttendeeOption[] = newValue.map((option: { value: any; label: any }) => ({
            id: option.value,
            value: option.label
        }));

        formik.setFieldValue('internalAttendees', updatedValues);

    };
    return (
        <div className={activityTogglePopup ? "toggle-popup sidebar-popup" : "toggle-popup"}>
            <div className="sidebar-layout">
                <div className="sidebar-header">
                    <h4>{aptId ? "Edit Appointment" : "Add Appointment"} </h4>
                    <Link to="#" className="sidebar-close toggle-btn" onClick={closeSidebar}>
                        <i className="ti ti-x" />
                    </Link>
                </div>
                <div className="toggle-body">
                    <div className="toggle-height">
                        <div className="pro-create">
                            <form onSubmit={formik.handleSubmit}>
                                <div className="row">
                                    <h5 className='text-gray mb-3'>Schedule Appointment</h5>
                                    <div className="mt-2">
                                        <TextField
                                            label="Appointment Title"
                                            type="text"
                                            {...formik.getFieldProps("aptTitle")}
                                        />
                                    </div>
                                    <div className="col-md-12 mt-2">
                                        <label className="input-label">
                                            Appointment Type (Category)<span className="text-danger"> *</span>
                                        </label>
                                        <Select
                                            styles={customStyles}
                                            className="select"
                                            options={aptbyId?.result?.
                                                lst_AppointmentType?.map((option: any) => ({
                                                    label: option?.value,
                                                    value: option?.id
                                                }))}
                                            value={
                                                formik.values?.lst_SelAppointmentType?.id
                                                    ? {
                                                        value: formik.values?.lst_SelAppointmentType?.id,
                                                        label: formik.values?.lst_SelAppointmentType?.value || '',
                                                    }
                                                    : null
                                            }
                                            // isDisabled={isReadOnly}
                                            onChange={(selectedOption: any) => {
                                                formik.setFieldValue('lst_SelAppointmentType.id', selectedOption.value);
                                                formik.setFieldValue('lst_SelAppointmentType.value', selectedOption.label);
                                            }}
                                        />
                                    </div>
                                    <div className="col-md-12 mt-2">
                                        <label className="input-label">
                                            Start Date <span className="text-danger">*</span>
                                        </label>
                                        <div className="form-wrap icon-form">
                                            <span className="form-icon">
                                                <i className="ti ti-calendar-check" />
                                            </span>
                                            <DatePicker
                                                className="form-control datetimepicker deals-details"
                                                selected={selectedDate}
                                                onChange={handleDateChange}
                                                value={formik.values?.startDate}
                                                dateFormat="dd-MM-yyyy"
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-6 mt-2">
                                        <label className="input-label">
                                            Start Time <span className="text-danger">*</span>
                                        </label>
                                        <TimePicker
                                            placeholder="Select Time"
                                            className="form-control datetimepicker-time"
                                            {...formik.getFieldProps('startTime')}
                                            onChange={onChangeStart}
                                            defaultOpenValue={dayjs("00:00 AM", "h:mm A")}
                                            format="h:mm A"
                                            use12Hours
                                            // Check if startTime exists and is a valid format before passing it to dayjs
                                            value={formik.values?.startTime && dayjs(formik.values.startTime, "h:mm A").isValid()
                                                ? dayjs(formik.values.startTime, "h:mm A")
                                                : null}
                                        />
                                        {/* 
                                        <TimePicker
                                            placeholder="Select Time"
                                            className="form-control datetimepicker-time"
                                            {...formik.getFieldProps('startTime')}
                                            value={formik.values?.startTime ? dayjs(formik.values?.startTime, "h:mm A") : null}
                                            onChange={(value) => {
                                                formik.setFieldValue('startTime', value);
                                            }}
                                        /> */}


                                    </div>
                                    <div className="col-md-6 mt-2">
                                        <label className="input-label">
                                            Duration<span className="text-danger"> *</span>
                                        </label>
                                        <Select
                                            styles={customStyles}
                                            className="select"
                                            options={
                                                getdefaultLookups?.result?.Lst_FreshAptDuration?.map((option: any) => ({
                                                    label: option?.value,
                                                    value: option?.id
                                                }))}
                                            value={
                                                formik.values?.lst_duration?.id
                                                    ? {
                                                        value: formik.values?.lst_duration?.id,
                                                        label: formik.values?.lst_duration?.value || '',
                                                    }
                                                    : null
                                            }
                                            // isDisabled={isReadOnly}
                                            onChange={(selectedOption: any) => {
                                                formik.setFieldValue('lst_duration.id', selectedOption.value);
                                                formik.setFieldValue('lst_duration.value', selectedOption.label);
                                            }}
                                        />
                                    </div>

                                    <div className="col-md-12 mt-2">
                                        <div className="form-wrap">
                                            <TextField
                                                label="Client Attendees"
                                                type="text"
                                                {...formik.getFieldProps("clientAttendees")}

                                            />
                                        </div>
                                    </div>
                                    {/* <div className="col-md-12 mt-2">
                                        <label className="input-label">
                                            Internal Attendees<span className="text-danger"> *</span>
                                        </label>
                                        <Select
                                            styles={customStyles}
                                            className="select"
                                            options={
                                                getallActiveUsers?.result?.map((option: any) => ({
                                                    label: option?.id,
                                                    value: option?.value
                                                }))}
                                            value={
                                                formik.values?.lst_internalAttendees?.id
                                                    ? {
                                                        value: formik.values?.lst_internalAttendees?.id,
                                                        label: formik.values?.lst_internalAttendees?.value || '',
                                                    }
                                                    : null
                                            }
                                            // isDisabled={isReadOnly}
                                            onChange={(selectedOption: any) => {
                                                formik.setFieldValue('lst_internalAttendees.id', selectedOption.value);
                                                formik.setFieldValue('lst_internalAttendees.value', selectedOption.label);
                                            }}
                                        />
                                    </div> */}
                                    <div className="col-md-12 mt-2">
                                        <div className="form-wrap">
                                            <label className="input-label">
                                                Internal Attendees<span className="text-danger"> *</span>
                                            </label>
                                            <Select
                                                isMulti={true}
                                                styles={customStyles}
                                                className="select multi-select"
                                                options={getallActiveUsers?.result?.map((option: any) => ({
                                                    label: option?.userName,
                                                    value: option?.userId
                                                })) || []}
                                                value={
                                                    selectValues
                                                }
                                                onChange={(newValue: any) => handleChange(newValue)}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-12 mt-2">
                                        <label className="input-label">
                                            Location<span className="text-danger"> *</span>
                                        </label>
                                        <Select
                                            styles={customStyles}
                                            className="select"
                                            options={
                                                getdefaultLookups?.result?.Lst_FreshAptLocation?.map((option: any) => ({
                                                    label: option?.value,
                                                    value: option?.id
                                                }))}
                                            value={
                                                formik.values?.lst_FreshAptLocation?.id
                                                    ? {
                                                        value: formik.values?.lst_FreshAptLocation?.id,
                                                        label: formik.values?.lst_FreshAptLocation?.value || '',
                                                    }
                                                    : null
                                            }
                                            // isDisabled={isReadOnly}
                                            onChange={(selectedOption: any) => {
                                                formik.setFieldValue('lst_FreshAptLocation.id', selectedOption.value);
                                                formik.setFieldValue('lst_FreshAptLocation.value', selectedOption.label);
                                            }}
                                        />
                                    </div>
                                    <div className="col-md-12 mt-2">
                                        <div className="form-wrap">
                                            {/* <TextField
                                                label="Location Notes"
                                                type="text"
                                                {...formik.getFieldProps("locationNotes")}

                                            /> */}
                                            <label className='input-label'>Location Notes</label>
                                            <textarea
                                                className='form-control w-100'
                                                rows={5}
                                                {...formik.getFieldProps("locationNotes")}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div className="submit-button text-end">
                            <button type='button' className="btn btn-light sidebar-close" onClick={closeSidebar}>
                                Cancel
                            </button>
                            <button
                                type='submit'
                                className="btn btn-primary"
                                onClick={handleSubmit}
                            >
                                {selectedIndividualCheckboxId[0] ? "Update" : "Save"}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AppointmentLeadSidebar;
